import { mapActions } from 'vuex';
import cmsContentMixin from '@/mixins/cmsContent';
import seoMetaMixin from '@/mixins/seoMeta';
import { DAILY_PAGES } from './daily-pages.constants';

export default {
  mixins: [
    cmsContentMixin,
    seoMetaMixin,
  ],
  props: {
    pageId: {
      type: String,
      required: true,
    },
  },
  metaInfo() {
    const info = Object.values(DAILY_PAGES)
    const pageData = info.find(i => i.pageId === this.pageId)

    return this.buildSeoMeta({
      title: (pageData || {}).title || 'Daily Markets',
    });
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.getStaticPageFull(this.pageId)
      .then((data) => {
        this.installDynamicControls({ data });
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-daily-markets-details/page-daily-markets-details.js